__turbopack_context__.v({
  "avatar": "AvatarSkeleton-module__5wIs3W__avatar",
  "shimmer": "AvatarSkeleton-module__5wIs3W__shimmer",
});
